export default __webpack_public_path__ + "static/media/logo_defender_club.5012c708.svg";